import React from "react";
import back from "../../assets/back.png";
import { Colors } from "../../utils/colors";
import { BottomSheet } from "../bottomSheet/BottomSheet";
import LoadingIndicator from "../loadingIndicator/LoadingIndicator";
import { PlayersList } from "../playersList/PlayersList";
import { SearchBar } from "../searchBar/SearchBar";
import { TCText } from "../TCText/TCText";
import { observer } from "mobx-react-lite";
import { useSelectCircleStore } from "../../stores/StoreContext";
import { Button } from "../button/Button";

type props = {
  showBottomSheet: boolean;
  closeBottomSheet: () => void;
};

export const ExcludePlayerBottomSheet: React.FC<props> = observer(
  ({ showBottomSheet, closeBottomSheet }) => {
    const selectCircleStore = useSelectCircleStore();
    return (
      <BottomSheet
        isVisible={showBottomSheet}
        onClose={() => closeBottomSheet()}>
        <div
          style={{ height: "90vh", display: "flex", flexDirection: "column" }}>
          <div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}>
              <div
                onClick={() => closeBottomSheet()}
                style={{ cursor: "pointer" }}>
                <img src={back} alt="back" width={11} height={18} />
              </div>
              <TCText
                style={{
                  fontWeight: 600,
                  fontSize: 16,
                  flex: 1,
                  alignSelf: "center",
                  textAlign: "center",
                }}
                value="Exclude players"
              />
            </div>
            <TCText
              style={{
                fontWeight: 600,
                fontSize: 18,
                flex: 1,
                marginTop: 20,
                marginBottom: 10,
              }}
              value="Search"
            />
            <SearchBar
              onSearch={(value) => selectCircleStore.setFilteredName(value)}
            />
          </div>
          <div
            style={{
              flex: 1,
              overflowY: "auto",
              msOverflowStyle: "none" /* IE and Edge */,
              scrollbarWidth: "none" /* Firefox */,
            }}>
            <PlayersList
              isExcludePlayers
              players={selectCircleStore.getPlayersList(true) ?? []}
            />
          </div>
          <div style={{ padding: 16, marginTop: "auto" }}>
            <Button
              text="Continue"
              onPress={() => {
                closeBottomSheet();
              }}
              btnStyle={{
                width: "100%",
                height: 56,
                backgroundColor: Colors.darkBrown,
              }}
              textStyle={{
                color: "white",
                fontWeight: 600,
                fontSize: 14,
              }}
            />
          </div>
          <LoadingIndicator loading={selectCircleStore.isLoading} />
        </div>
      </BottomSheet>
    );
  }
);
